define("shared/utils/formatters/pin-from-dynamo", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Formats a raw dynamo pin response
   *
   * @method createPinFromDynamo
   * @param {RawDynamoPin} obj Raw dynamo pin object
   *
   * @returns {FormattedDynamoPin} Returns a formatted pin
   */
  function createPinFromDynamo(pin) {
    return {
      id: pin.id,
      pinnerId: pin.pinner_id,
      boardId: pin.board_id,
      link: pin.link,
      standardResUrl: pin.image_medium_url,
      thumbUrl: pin.image_medium_url,
      isDeleted: false,
      createdTime: pin.created_time,
      caption: pin.description,
      followersCount: pin.followers_on_post,
      repinCount: pin.repin_count,
      commentCount: pin.comment_count,
      shortcodes: pin.shortcodes,
      clicks: pin.clicks,
      type: 'pin'
    };
  }
  var _default = _exports.default = createPinFromDynamo;
});